import styled from 'styled-components';
import ribbon from 'assets/offer/ribbon.png';

export const OfferContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  background-color: #fff9ef;
  border-bottom: 7px solid #e8d4c3;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 2rem;
  min-width: ${({ $offersLength }) => ($offersLength > 2 ? '400px' : '500px')};
  text-align: center;
  @media (max-width: 1015px) {
    min-width: ${({ $offersLength }) => ($offersLength > 1 ? '370px' : '400px')};
  }
  @media (max-width: 560px) {
    min-width: ${({ $offersLength }) => ($offersLength > 1 ? '270px' : '320px')};
  }
`;

export const Ribbon = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${ribbon}) no-repeat;
  background-size: contain;
  width: 75px;
  height: 56px;
  top: -2px;
  left: -2px;
`;

export const RibbonText = styled.span`
  color: #ffffff;
  font-weight: 700;
  margin-right: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 1.2em;
`;

export const PackageId = styled.div`
  position: absolute;
  color: #ffffff;
  right: 25px;
  top: 2px;
  font-weight: 700;
  font-size: 0.9em;
  text-shadow: 0px 1px 1px black;
`;

export const Header = styled.div`
  background: ${({ $background }) => `url(${$background}) no-repeat center`};
  background-size: cover;
  border-radius: 2rem 2rem 0 0;
  padding: 1.5rem;
`;

export const Icon = styled.img.attrs(({ src }) => ({
  src,
}))`
  width: 180px;
  height: 150px;
`;

export const Fotter = styled.div`
  display: flex;
  flex-direction: column;
  color: #1f1f1f;
  gap: 0.5rem;
  padding: 1rem;
  flex: 1;
`;

export const Price = styled.div`
  text-decoration: line-through red;
  text-decoration-thickness: 0.2rem;
  -webkit-text-decoration: line-through red;
  -webkit-text-decoration-thickness: 0.2rem;
  font-size: 1.3em;
  font-weight: 800;
`;
